<template>
  <div class="video-list-content">
    <tip></tip>
    <template v-if="videoObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <div class="video-content-box">
        <div class="video-content">
          <bVideo
              v-if="isInitPlay"
              ref="bVideo"
              :videoId="videoId"
              :playerOptions="playerOptions">
          </bVideo>
        </div>
      </div>

      <div class="flex-content" v-if="videoObj && videoObj.title">
        <div class="text-content">
          <div class="title" @click="topage">
          <span class="hs-title">
            {{ videoObj.title.slice(0,15) }}
          </span>
            <span class="zhuanji">专辑</span>
          </div>
          <div class="header-img">
            <img :src="videoObj.author_pic" alt="">
            <div class="header-title" v-if="videoObj.author_name">{{ videoObj.author_name.slice(0,15) }}</div>
            <div class="buylink" v-if="videoObj.buy_link" @click="toBuy(videoObj.buy_link)">
              购买此书
            </div>
          </div>
          <div class="synopsis">
            <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{videoObj.intro}}</p>
            <span @click="zhankaiFn" v-if="videoObj.intro && videoObj.intro.length > 48">
            <img v-if="!iszhankai" src="../../assets/img/zhankan.png" alt="">
            <img v-if="iszhankai" src="../../assets/img/shouqi.png" alt="">
          </span>
          </div>
        </div>
        <div class="list-content-box" v-if="videoList.length">
          <div class="list-content">
            <div class="xuanji">
              <h3>选集</h3>
              <ul>
                <li v-for="(item, i) in videoObj.video_segmen" class="li-item" :class="{ active: i === index }" @click="changeVidelList(i)" :key="i">{{ item }}</li>
              </ul>
            </div>
            <div class="item-box" v-if="itemList.length">
              <div class="item-list" v-for="item in itemList" :class="{ active: item.id == videoId }" :key="item.id" @click="palyItemVideo(item,true)">
                <div class="cover_pic" >
                  <div class="mengceng" v-if="item.id == videoId">

                    <div class="spinner" v-if="!isPlay">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                    </div>
                    <div class="spinner spinner2" v-else>
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                    </div>
                  </div>
                  <div v-else class="min">
                    {{item.min}}
                  </div>
                  <div v-if="!canView&&item.view_pass" class="pass">
                    <img src="../../assets/img/lock.png" style="width: 32px; height: 32px;">
<!--                    <svg t="1741188517717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8049" width="32" height="32">-->
<!--                      <path d="M787.16806 952.268282 236.83194 952.268282c-30.395264 0-55.033407-24.638143-55.033407-55.033407L181.798533 429.449889c0-30.395264 24.638143-55.033407 55.033407-55.033407l82.550111 0 0-110.066815c0-106.379842 86.238107-192.617949 192.617949-192.617949s192.617949 86.238107 192.617949 192.617949l0 110.066815 82.550111 0c30.395264 0 55.033407 24.638143 55.033407 55.033407l0 467.784986C842.201467 927.630139 817.562301 952.268282 787.16806 952.268282zM484.483296 672.046113l0 115.121947 55.033407 0 0-115.121947c31.990598-11.373025 55.033407-41.605583 55.033407-77.496002 0-45.592384-36.957727-82.550111-82.550111-82.550111s-82.550111 36.957727-82.550111 82.550111C429.449889 630.440529 452.491675 660.673088 484.483296 672.046113zM622.066815 264.348644c0-60.787458-49.279357-110.066815-110.066815-110.066815s-110.066815 49.279357-110.066815 110.066815l0 110.066815 220.134653 0L622.067838 264.348644z" fill="#ffffff" p-id="8050">-->
<!--                        -->
<!--                      </path>-->
<!--                    </svg>-->
                  </div>
                  <img :src="item.cover_pic" alt="">
                </div>
                <div class="item-name">{{item.name}}</div>
              </div>
              <div class="width20"></div>
            </div>
          </div>
        </div>
        <div v-if="videoObj && videoObj.title && !videoList.length" class="xiajia"><empty></empty></div>
      </div>
      <Dialog
          :visible="showDialog"
          title="请输入密码"
          @close="showDialog = false"
          @cancel="showDialog = false"
          @confirm="handleConfirm"
      />
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from "@/components/empty.vue";
import bVideo from '@/components/bVideo.vue';
import {Indicator, Toast} from 'mint-ui';
import wechat from "@/plugins/wx";
import Dialog from '@/components/dialog.vue';
  export default {
    components: {
      tip,
      bVideo,
      Dialog,
      empty,
    },
    data() {
      return {
        isInitPlay: false,
        id: 0,
        iszhankai: false,
        topVideo: false,
        topVideoObj: {},
        bottomVideo: true,
        bottomVideoObj: {},
        playerOptions: {
          //是否显示控制栏
          controls: true,
          // muted: true,
          language: 'en',
          sources: [
            {
              type: "video/mp4",
              src: "http://ayerdudu.sunnyint.net/video/2.mp4"
            }
          ],
          poster: "/static/images/author.jpg",
        },
        itemVideoObj:{},
        videoObj:{},
        videoList:[],
        index: 0,
        videoId: 0,
        loadFlag: true,
        itemList: [],
        isPlay: false,
        shareConfig: {
          title: '分享标题',
          desc: '这是一个测试的微信分享',
          link: '', // 分享链接
          imgUrl: '', // 分享图标
        },
        viewPass:true,
        showDialog:false,
        canView:false,
        selectItem:{}
      }
    },
    created () {
      this.id = this.$route.query.id || 1
      this.getVideoList()
      this.report(this.id,6)
    },
    methods: {
      handleConfirm(value) {
        if(value==this.videoObj.view_pass){
          localStorage.setItem(`videoList-auth-${this.id}`, value);
          this.showDialog = false
          this.canView = true;
        }else{
          Toast({
            message:'密码不对！',
          });
        }
        // console.log('输入内容:', value,this.selectItem);
        // if(value==this.selectItem.view_pass){
        //   sessionStorage.setItem(`view_pass_key_${this.selectItem.id}`, value);
        //   this.showDialog = false
        //   this.palyItemVideo(this.selectItem,)
        // }else{
        //   Toast({
        //     message:'密码不对！',
        //   });
        // }

      },
      toBuy(link){
        window.open(link, '_blank');
      },
      async report(id,dt) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":dt
          });

        } catch (error) {
          console.error("Error sending click request:", error);
        }
      },
      topage(){
        this.$router.push(`/videoAlbum?id=${this.id}`)
      },
      zhankaiFn(){
        this.iszhankai = !this.iszhankai
      },
      changeVidelList(index){
        this.itemList = []
        this.index = index
        setTimeout(() => {
          this.itemList = this.videoList[index].items
        }, 0)
      },
      async getVideoList() {
        try {
          Indicator.open()
          this.id = this.$route.query.id || 1
          //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/vai_${this.id}.html`)
          const res = await this.axios.get(`https://api.ayerdudu.com/v1/video/album/signData/${this.id}`)
          //const res = await this.axios.get(`http://localhost:8080/v1/video/album/signData/${this.id}`)
          this.videoObj = res.data.data
          console.log(this.videoObj)
          const currentUrl = window.location.href.split('#')[0];
          this.shareConfig.title = this.videoObj.title;
          this.shareConfig.desc = this.videoObj.intro;
          this.shareConfig.link = currentUrl;
          this.shareConfig.imgUrl = this.videoObj.surface_pic;
          console.log('分享配置',this.shareConfig);
          //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
          wechat.initConfig(currentUrl).then(() => {
            // 配置分享内容
            wechat.setShareOptions(this.shareConfig);
          });
          this.canView = this.$checkViewPass("videoList-auth-"+this.id,this.videoObj.view_pass);
          this.videoList = res.data.data.video_list
          this.itemList = this.videoList[0].items
          if(this.canView){
            this.palyItemVideo(this.videoList[0].items[0])
          }

          Indicator.close()
        } catch (err) {
          Indicator.close()
          console.log(err)
        }
      },
      checkAccess(item) {
        let view_pass = item?.view_pass;
        if(view_pass==undefined){
          return true
        }
        // 检查 item 是否存在 view_pass 且非空
        if (view_pass.trim() !== '') {
          // 从 sessionStorage 读取指定 key 的值（假设 key 为 'view_pass_key'）
          const storedValue = sessionStorage.getItem(`view_pass_key_${item.id}`);

          // 检查存储的值是否存在且与 item.view_pass 一致
          if (storedValue !== null && storedValue === item.view_pass) {
            return true; // 满足条件返回 true
          }else{
            return false;
          }
        }
        return true; // 其他情况返回 false
      },
      palyItemVideo(item, play=false){
        if(!this.canView&&item.view_pass!=""){
          this.showDialog = true;
          return;
        }
         if(this.playerOptions.sources[0].src === item.url && this.$refs.bVideo.play){
          return
        } 
        this.videoId = item.id
        this.isInitPlay = false
        this.playerOptions = {
          // muted: true,
          //是否显示控制栏
          controls: true,
          timeDivider: false,
          language: 'en',
          sources: [
            {
            type: "video/mp4",
            src: item.url
          }
          ],
          poster: item.cover_pic,
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          },
          playbackRates: [0.7, 1.0,1.25, 1.5, 2.0,3.0],
        }
        this.isInitPlay = true
        if(play){
          setTimeout(() => {
            this.$refs.bVideo.player.play()
            this.$refs.bVideo.play = true
          }, 100)
          
        }
      }
    },
    
  }
</script>

<style lang="less" scoped>
.video-list-content{
  height: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
}
.video-content-box{
  height: 420px;
  width: 100%;
  background: #000;
  overflow: hidden;
  // border-bottom: 1px solid #eee;
}
.video-content{
  height: 100%;
  width: 100%;
  background: #000;
  overflow: hidden;
  border-bottom: 1px solid #bfbfbf;
  video{
    width: 100%;
    height: 100%;
  }
}
.flex-content{
  flex: 1;
  overflow: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display:none
  }
}
.title{
  height: 115px;
  .hs-title{
    display: block;
    font-size: 36px;
    float: left;
    line-height: 115px;
    font-weight: bold;
  }
  .zhuanji{
    float: left;
    margin-left: 10px;
    font-size: 20px;
    background: #22b07d;
    height: 36px;
    color: #fff;
    padding: 0 8px;
    border-radius: 5px;
    line-height: 37px;
    margin-top: 36px;
    transform: scale(0.8);
  }
}
.header-img{
  width: 100%;
  height: 64px;
  display: flex;
  margin-bottom: 22px;
  img{
    width: 64px;
    height: 64px;
    margin-right: 18px;
    border-radius: 50%;
    box-shadow: 1px solid #bfbfbf;
  }
  .header-title{
    flex: 1;
    line-height: 64px;
    font-size: 26px;
    color: #202020;
  }
  .buylink{
    float: right;
    //background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #f6451b;
    border-color: #f6451b;
    font-size: 24px;
    border: 2px solid #f6451b;
    margin-right: 30px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }
}
.text-content{
  box-sizing: border-box;
  width: 100%;
  padding: 0 38px;
  background: #fff;
}
.synopsis{
  font-size: 24px;
  color: #888;
  display: flex;
  padding-bottom: 28px;

  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}
.list-content-box{
  background: #fff;
  width: 100%;
  min-height: 200px;
}
.list-content{
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  padding-bottom: 40px;
  padding-left: 38px;
  position: relative;
  box-sizing: border-box;
  .xuanji{
    display: flex;
    height: 46px;
    padding-top: 46px;
    h3{
      font-size: 34px;
      color: #000;
      font-weight: bold;
      margin-right: 34px;
      line-height: 46px;
    }
    ul{
      flex: 1;
      overflow: hidden;
      white-space:nowrap;
      overflow-x:scroll;
      &::-webkit-scrollbar {
        display:none
      }
      .li-item{
        display: inline-block;
        margin-right: 24px;
        height: 46px;
        line-height: 46px;
        padding: 0px 24px;
        background: #fff;
        color: #202020;
        font-size: 26px;
        border-radius: 24px;
        vertical-align: middle; // 此处新增
        &.active{
          color: #f6451b;
          background: rgba(246,69,27, 0.05);
        }
      }
      .width20{
        display: inline-block;
        width: 200px;
        vertical-align: top; // 此处新增
      }
    }
  }
}
.item-box{
  margin-top: 28px;
  height: 270px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .width20{
    display: inline-block;
    height: 268px;
    width: 40px;
  }
  .item-list{
    display: inline-block;
    height: 268px;
    width: 254px;
    overflow: hidden;
    border-radius: 10px;
    margin-right: 24px;
    background: #fff;
    vertical-align: top; // 此处新增


    .cover_pic{
      display: block;
      width: 100%;
      height: 160px;
      position: relative;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
      .pass{
        position: absolute;
        /* 以下两行实现垂直水平居中 */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%); /* 关键：基于自身尺寸偏移 */

        /* 以下为容器样式 */
        //background: rgba(0, 0, 0, .3);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        //padding: 12px; /* 如果有需要可以保留 */

        /* 新增以下代码让 SVG 居中 */
        display: flex;
        align-items: center;
        justify-content: center;
        svg{
          width: 100%;
          height: 100%;
        }
      }
    }
    .item-name{
      box-sizing: border-box;
      display: inline-block;
      overflow: hidden;
      padding: 17px 17px 20px;
      width: 100%;
      height: 85px;
      font-size: 25px;
      line-height: 36px;
      white-space: normal;
      // text-overflow: -o-ellipsis-lastline;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .mengceng{
      display: none;
    }
    .min{
      position: absolute;
      display: inline-block;
      top: 120px;
      right: 11px;
      font-size: 24px;
      background: rgba(0, 0, 0, .3);
      border-radius: 14px;
      color: #fff;
      padding: 0 12px;
      height: 32px;
      line-height: 33px;
    }
    &.active{
      .item-name{
        color: #f6451b;
      }
      .mengceng{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background:rgba(0, 0, 0, 0.25);
      }
    }
  }
  
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 10px;
  margin-left: -20px;
  margin-top: -25px;
}
 
.spinner > div {
  background-color: #fff;
  height: 100%;
  width: 7px;
  display: inline-block;
  margin-right: 7px;
  border-radius: 10px;
  position: absolute;
  bottom: 0;
}

.spinner .rect1 {
  left: 0px;
  height: 25px;
}

.spinner .rect2 {
  left: 14px;
  height: 35px;
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
 
.spinner .rect3 {
  left: 28px;
  height: 32px;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner2 > div{
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}

 
@-webkit-keyframes stretchdelay {
  0%, 40%, 100% { height: 25px; } 
  20% { height: 40px; }
}
 
@keyframes stretchdelay {
  0%, 40%, 100% {
    height: 25px; 
  }  20% {
    height: 40px; 
  }
}
.xiajia{
  font-size: 26px;
  text-align: center;
  line-height: 80px;
}
</style>